import { createSlice } from "@reduxjs/toolkit";

export const reportdata = createSlice({
    name: 'reportdata',

    initialState: {
        selectedTreeItem: "generation",
        reporttreepathselected: ['Generation'],
        selectedreporttabpath: [],
    },

    reducers: {
        setSelectedTreeItem: (state, treeItem) => {
            state.selectedTreeItem = treeItem.payload
        },
        updatereporttreepathselected: (state, reporttreepath) => {
            state.reporttreepathselected = reporttreepath.payload
        },
        updatereporttabpath: (state, reporttabpath) => {
            state.selectedreporttabpath = reporttabpath.payload
        },
    }
})

export const { setSelectedTreeItem, updatereporttreepathselected, updatereporttabpath } = reportdata.actions
export default reportdata.reducer